'use client';

import { TextField, InputAdornment } from '@mui/material';
import { SearchIcon } from '@/shared/ui/display/EmojiIcon';

interface ToolbarSearchProps {
  value: string;
  onChange: (value: string) => void;
  onEnter?: () => void;
  placeholder?: string;
  width?: number | string;
}

export function ToolbarSearch({
  value,
  onChange,
  onEnter,
  placeholder = '검색...',
  width = 300,
}: ToolbarSearchProps) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && onEnter) {
      onEnter();
    }
  };

  return (
    <TextField
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: 'text.secondary' }} />
          </InputAdornment>
        ),
      }}
      sx={{
        width,
        '& .MuiOutlinedInput-root': {
          height: '32px',
          fontSize: '0.875rem',
        },
      }}
    />
  );
}
